import { StyledErrorInFieldDiv } from "./Input.styles";

/**
 * ErrorInField Component
 *
 * Displays an error message for a specific form field using styled component styling.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {string} props.message - The error message to display
 *
 * @returns {JSX.Element} A styled error message element
 *
 */

export const ErrorInField = ({ message }) => {
  return <StyledErrorInFieldDiv>{message}</StyledErrorInFieldDiv>;
};
